export default {
	colorPrimary   : '#026A44',
	colorSecondary : '#89B831',
	colorAccent    : '#E5BF11',
	bgColor        : '#F1F9F5',
	color          : '#fff',
	grey           : '#555555',
	white          : '#ffffff',
	lineColors     : ['#5A726A', '#89B831', '#F8A79E', '#E5BF11'],
	payableColors  : ['#99CA3C', '#89B831', '#689C05'],
	qualityColors  : ['#E5BF11', '#80AB2C', '#F8A79E'],
	insectColor    : '#E8C528'
};
